import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
@Component({
    selector: 'lib-login',
    imports: [MatProgressSpinnerModule],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})
export class LoginComponent {
    private readonly authService = inject(AuthService);
    private readonly route = inject(ActivatedRoute);

    constructor() {
        this.route.queryParams.pipe(
            takeUntilDestroyed()
        ).subscribe(queryParams => {
            let returnUrl = queryParams['returnUrl'] as string;
            this.authService.login(returnUrl);
        });
    }
}
